import { Loader } from '@googlemaps/js-api-loader';

export function googleMapInitializer(apiKey: string, libraries: any[]): () => Promise<any> {
  const loader = new Loader({
    apiKey,
    libraries: libraries || [],
    // version: 'beta',
  });

  return () => loader.load();
}
